import React, { useState, useEffect } from "react";
import { WifiIcon, WifiOffIcon } from "../../Utils/SVGs";
import { ContrastColor } from "../../Utils/constants";

const InternetStatus = () => {
  const [isOnline, setIsOnline] = useState(window.navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <div>
      {isOnline ? WifiIcon(ContrastColor, 20) : WifiOffIcon(ContrastColor, 20)}
    </div>
  );
};

export default InternetStatus;
